import { sileo } from "sileo";
import i18n from "i18next";

import { subscriptionService } from "./subscriptionService";

/**
 * Abre el checkout del add-on de "workspaces concurrentes en cloud" (sub-suscripción
 * del plan padre). Reusado por la pantalla Subscription (botón "Agregar más") y por el
 * CTA del toast de límite de concurrencia al transmitir.
 *
 * Maneja los casos del backend:
 *  - ADDON_DEDICATED_ONLY: el plan es Lite (1 workspace fijo) → solo Dedicated puede sumar.
 *  - ADDON_NOT_CONFIGURED: el producto Creem del add-on aún no está cargado → "próximamente".
 *
 * Usa la instancia global de i18n con keys namespaced ("settings:") para funcionar desde
 * cualquier pantalla, sin importar el namespace del `useTranslation` del caller.
 */
export async function openWorkspaceAddonCheckout(): Promise<void> {
  await i18n.loadNamespaces("settings");
  const tt = (k: string): string =>
    i18n.t(`settings:SETTINGS.FORMS.SUBSCRIPTION.${k}`);

  try {
    const { url } = await subscriptionService.createWorkspaceAddonCheckout();

    if (window.electronAPI?.openExternal) {
      await window.electronAPI.openExternal(url);
    } else {
      window.open(url, "_blank");
    }

    sileo.info({
      title: tt("checkoutOpened"),
      description: tt("checkoutOpenedDesc"),
      duration: 6000,
    });
  } catch (err) {
    const msg = err instanceof Error ? err.message : "";

    if (msg.includes("ADDON_DEDICATED_ONLY")) {
      sileo.info({
        title: tt("addWorkspaceLiteTitle"),
        description: tt("addWorkspaceLiteDesc"),
        duration: 6000,
      });
    } else if (msg.includes("ADDON_NOT_CONFIGURED")) {
      sileo.info({
        title: tt("addWorkspaceTitle"),
        description: tt("addWorkspaceDesc"),
        duration: 6000,
      });
    } else {
      sileo.error({
        title: tt("checkoutError"),
        description: tt("checkoutErrorDesc"),
        duration: 5000,
      });
    }
  }
}
